import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import HomePage from "../pages/home/page";
import CommercialCleaningPage from "../pages/services/commercial-cleaning/page";
import AboutPage from "../pages/about/page";
import HoustonPage from "../pages/locations/houston/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/services/commercial-cleaning",
    element: <CommercialCleaningPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/locations/houston",
    element: <HoustonPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
